export const categories = [
  { name: 'Schuhe', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweater', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jacken', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Hosen/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Kopfbedeckung', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Unterwäsche', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Trikots', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessoires', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Taschen', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Gürtel', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Parfums', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Sonstiges', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export const testimonials = [
  {
    name: 'Lukas M.',
    location: 'Berlin',
    rating: 5,
    title: 'Schneller Versand',
    text: 'Ich habe über das OOPBUY Spreadsheet Sneaker bestellt und war überrascht, wie schnell die Lieferung nach Berlin kam. Die QC-Bilder waren extrem hilfreich – so wusste ich genau, was mich erwartet. Absolut empfehlenswert für jeden, der aus Deutschland bestellt.',
  },
  {
    name: 'Sophie K.',
    location: 'München',
    rating: 5,
    title: 'Perfekte Qualitätskontrolle',
    text: 'Dank des OOPBUY Spreadsheets habe ich endlich den Durchblick bei meinen Bestellungen. Die QC-Checks sind Gold wert – ich konnte ein fehlerhaftes Produkt vor dem Versand reklamieren. Der Kundenservice war top!',
  },
  {
    name: 'Maximilian W.',
    location: 'Hamburg',
    rating: 5,
    title: 'Bester Spreadsheet-Guide',
    text: 'Das OOPBUY Spreadsheet hat mir als Anfänger unglaublich geholfen. Die Kategorien sind übersichtlich, die Links funktionieren einwandfrei und ich habe innerhalb von 10 Tagen meine erste Bestellung aus China erhalten. Wahnsinn!',
  },
  {
    name: 'Anna-Lena R.',
    location: 'Wien',
    rating: 4,
    title: 'Großartige Auswahl',
    text: 'Ich nutze das OOPBUY Spreadsheet seit drei Monaten für meine Mode-Bestellungen. Die Vielfalt an Kategorien – von Schuhen über Hoodies bis zu Taschen – ist beeindruckend. Besonders die Taobao-Integration hat mich überzeugt.',
  },
  {
    name: 'Felix B.',
    location: 'Zürich',
    rating: 5,
    title: 'Sicher & vertrauenswürdig',
    text: 'Anfangs war ich skeptisch bei Bestellungen aus China. Das OOPBUY Spreadsheet hat alle meine Bedenken zerstreut. Transparente Abwicklung, klare Versandinformationen und ein super Support-Team. Fünf Sterne!',
  },
  {
    name: 'Nina S.',
    location: 'Köln',
    rating: 5,
    title: 'Bester Einkaufsassistent',
    text: 'Das OOPBUY Spreadsheet ist mein täglicher Begleiter beim Online-Shopping. Die ständig aktualisierten Links zu Weidian, Taobao und 1688 sparen mir Stunden an Recherche. Für den DACH-Raum einfach unverzichtbar.',
  },
];

export const features = [
  {
    icon: 'ri-file-list-3-line',
    title: 'Spreadsheet-Guide',
    description: 'Unser detaillierter OOPBUY Spreadsheet Guide führt Sie Schritt für Schritt durch den gesamten Bestellprozess. Von der Produktsuche bis zur Lieferung – alles übersichtlich auf Deutsch erklärt.',
  },
  {
    icon: 'ri-check-double-line',
    title: 'QC-Check',
    description: 'Mit dem integrierten QC-System prüfen Sie jede Bestellung vor dem Versand. Hochauflösende Bilder zeigen jedes Detail – so vermeiden Sie böse Überraschungen und sparen Retourenkosten.',
  },
  {
    icon: 'ri-ship-line',
    title: 'Shipping-Info',
    description: 'Aktuelle Versandinformationen für Deutschland, Österreich und die Schweiz. Erfahren Sie, welche Versandmethode am schnellsten und günstigsten in den DACH-Raum liefert.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Sicher Einkaufen',
    description: 'Ihre Sicherheit steht an erster Stelle. Das OOPBUY Spreadsheet arbeitet nur mit verifizierten Händlern und bietet Käuferschutz für jede Transaktion. SSL-verschlüsselt und DSGVO-konform.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Live-Updates',
    description: 'Die Spreadsheet-Links werden kontinuierlich aktualisiert. Neue Shops, aktuelle Coupons und die neuesten Produkte erscheinen automatisch – Sie verpassen kein Angebot mehr.',
  },
  {
    icon: 'ri-global-line',
    title: 'DACH-Optimiert',
    description: 'Speziell für Käufer aus Deutschland, Österreich und der Schweiz optimiert. Alle Informationen zu Zoll, Einfuhrumsatzsteuer und lokalen Versandoptionen sind integriert.',
  },
];

export const faqItems = [
  {
    question: 'Was ist das OOPBUY Spreadsheet?',
    answer: 'Das OOPBUY Spreadsheet ist ein umfassender Einkaufsassistent für den DACH-Raum. Es bietet strukturierte Kategorien, direkte Links zu vertrauenswürdigen Shops auf Plattformen wie Taobao, Weidian und 1688 sowie integrierte QC-Checks und Versandinformationen. Es ist Ihr persönlicher Guide für sicheres und effizientes Online-Shopping aus China.',
  },
  {
    question: 'Ist das OOPBUY Spreadsheet sicher?',
    answer: 'Ja, absolute Sicherheit hat höchste Priorität. Das OOPBUY Spreadsheet arbeitet ausschließlich mit verifizierten Händlern zusammen. Alle Transaktionen sind durch Käuferschutz abgesichert, die Verbindung ist SSL-verschlüsselt und sämtliche Daten werden DSGVO-konform verarbeitet.',
  },
  {
    question: 'Wie funktioniert der QC-Check?',
    answer: 'Der QC-Check (Quality Control) funktioniert in drei Schritten: Nach Ihrer Bestellung erhält das Warehouse die Ware und macht hochauflösende Fotos aus allen Winkeln. Sie können diese Bilder in Ihrem Dashboard einsehen und die Qualität prüfen. Bei Mängeln können Sie die Annahme verweigern – das Geld wird zurückerstattet.',
  },
  {
    question: 'Wie lange dauert der Versand nach Deutschland?',
    answer: 'Die Versanddauer hängt von der gewählten Methode ab. Mit Express-Versand (DHL, FedEx) erreichen Pakete Deutschland in 5-8 Werktagen. Standard-Versand benötigt 10-20 Werktage. Das OOPBUY Spreadsheet zeigt für jede Bestellung die geschätzte Lieferzeit an.',
  },
  {
    question: 'Welche Zahlungsmethoden werden akzeptiert?',
    answer: 'Das OOPBUY Spreadsheet unterstützt alle gängigen Zahlungsmethoden: Kreditkarte (Visa, Mastercard), PayPal, Banküberweisung sowie lokale Zahlungsoptionen für den DACH-Raum. Alle Zahlungen sind durch den integrierten Käuferschutz abgesichert.',
  },
  {
    question: 'Kann ich Produkte zurücksenden?',
    answer: 'Ja, Rückgaben sind möglich. Dank des QC-Checks erkennen Sie Mängel jedoch bereits vor dem internationalen Versand, sodass Retouren über Ländergrenzen hinweg selten nötig sind. Sollte dennoch eine Rücksendung erforderlich sein, unterstützt Sie der Support bei der Abwicklung.',
  },
  {
    question: 'Was kostet die Nutzung des OOPBUY Spreadsheets?',
    answer: 'Die Nutzung des OOPBUY Spreadsheets ist grundsätzlich kostenlos. Sie zahlen nur die tatsächlichen Produkt- und Versandkosten. Es gibt keine versteckten Gebühren oder Abonnements – volle Kostentransparenz für alle Nutzer im DACH-Raum.',
  },
  {
    question: 'Welche Plattformen sind im Spreadsheet integriert?',
    answer: 'Das OOPBUY Spreadsheet integriert die wichtigsten chinesischen Shopping-Plattformen: Taobao (größter C2C-Marktplatz), Weidian (beliebt für Streetwear und Sneaker), 1688 (Großhandel und B2B) sowie ausgewählte unabhängige Shops. Alle Links werden regelmäßig geprüft und aktualisiert.',
  },
  {
    question: 'Gibt es Rabattcodes oder Coupons?',
    answer: 'Ja, das OOPBUY Spreadsheet enthält eine spezielle Coupon-Sektion mit aktuellen Rabattcodes für den DACH-Raum. Diese werden regelmäßig aktualisiert und umfassen sowohl Neukundenrabatte als auch saisonale Aktionen. Ein Blick in die Coupon-Übersicht lohnt sich vor jeder Bestellung.',
  },
  {
    question: 'Ist das Spreadsheet auch für Anfänger geeignet?',
    answer: 'Absolut! Das OOPBUY Spreadsheet wurde speziell auch für Einsteiger entwickelt. Die Benutzeroberfläche ist intuitiv, jede Kategorie ist klar beschrieben und der integrierte Guide erklärt jeden Schritt verständlich auf Deutsch. Sie benötigen keine Vorkenntnisse im internationalen Online-Shopping.',
  },
];